<template>
    <div class="badgebox bg-color-secondary">
        <slot />
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.badgebox {
    margin: 35px auto 35px;
    padding: 33px 42px 15px;
    max-width: 730px;
    min-height: 164px;

    a {
        cursor: pointer;
    }

    &-footer {
        padding: 20px 0 0;
    }
}
</style>
